import api from '@api/endpoints';
import { getErrorMessage } from '@utils';
import { CASE_INVESTIGATION_MANAGER_CONSTANTS as types } from '@store/constants';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';
import { caseInvestigationManagerConfigBuilder } from '@views/CaseInvestigationManager/utils';


export const getDashboardConfig = () => async (dispatch) => {
  try {
    dispatch({
      type: types.GETTING_CASE_INVESTIGATION_MANAGER_CONFIG
    });

    const data = caseInvestigationManagerConfigBuilder();

    dispatch({
      type: types.GET_CASE_INVESTIGATION_MANAGER_CONFIG_SUCCESS,
      payload: data
    });

  } catch (error) {
    dispatch(
      setAlert({
        title: getErrorMessage({
          error,
          genericMessage: 'Failed to get Case Investigation Manager Config'
        }),
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
  }
};



export const getAllCaseInvestigations = ({ payload, onSuccess, onComplete }) => async (dispatch) => {
  try {
    dispatch({
      type: types.GETTING_CASE_INVESTIGATIONS,
      payload: payload
    });

    const requestPayload = {
      ...payload,
      pageSize: payload.pageSize || 20
    };

    const { data } = await api.caseInvestigationManager.getAllCaseInvestigations(requestPayload);

    dispatch({
      type: types.GET_CASE_INVESTIGATIONS_SUCCESS,
      payload: {
        result: data?.data,
        totalPage: data?.totalPages
      }
    });

    onSuccess && onSuccess(data);

  } catch (error) {
    dispatch(
      setAlert({
        title: 'Failed to get case investigations',
        status: ALERT_STATUS_TYPE.ERROR
      })
    );

    dispatch({
      type: types.GET_CASE_INVESTIGATIONS_FAILURE,
      payload: error?.message
    });
  } finally {
    onComplete && onComplete();
  }
};


export const getCaseInvestigationDetails = ({ caseId, onSuccess, onComplete }) => async (dispatch) => {
  try {
    dispatch({
      type: types.GETTING_CASE_INVESTIGATION_DETAILS,
      payload: caseId
    });

    const { data } = await api.caseInvestigationManager.getCaseInvestigationDetails({ caseId });

    dispatch({
      type: types.GET_CASE_INVESTIGATION_DETAILS_SUCCESS,
      payload: data
    });

    onSuccess && onSuccess(data);

  } catch (error) {
    dispatch(
      setAlert({
        title: 'Failed to get case investigation details',
        status: ALERT_STATUS_TYPE.ERROR
      })
    );

    dispatch({
      type: types.GET_CASE_INVESTIGATION_DETAILS_FAILURE,
      payload: error?.message
    });
  } finally {
    onComplete && onComplete();
  }
};


export const createNewCaseInvestigation = ({ payload, onSuccess, onComplete }) => async (dispatch) => {
  try {
    dispatch({
      type: types.CREATING_NEW_CASE_INVESTIGATION,
      payload: payload
    });

    const { data } = await api.caseInvestigationManager.createNewCaseInvestigation(payload);

    // NOTE :: Only adding total page and result in the redux store
    const { result, totalPage } = data;

    dispatch({
      type: types.CREATE_NEW_CASE_INVESTIGATION_SUCCESS,
      payload: {
        result,
        totalPage
      }
    });

    onSuccess && onSuccess(data);

  } catch (error) {
    dispatch(
      setAlert({
        title: 'Failed to create a case investigation',
        status: ALERT_STATUS_TYPE.ERROR
      })
    );

    dispatch({
      type: types.CREATE_NEW_CASE_INVESTIGATION_FAILURE,
      payload: error?.message
    });
  } finally {
    onComplete && onComplete();
  }
};


export const updateCaseInvestigationStatusByCaseId = ({ caseGuid, status, onSuccess, onComplete}) => async (dispatch) => {
  try {
    const { data } = await api.caseInvestigationManager.updateCaseInvestigationStatusByCaseId({ caseGuid, status });

    dispatch(
      setAlert({
        title: `Successfully updated the case status to ${status}`,
        status: ALERT_STATUS_TYPE.SUCCESS
      })
    );

    onSuccess && onSuccess(data);

  } catch (error) {
    dispatch(
      setAlert({
        title: 'Failed to update the case status',
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
  } finally {
    onComplete && onComplete();
  }
};


export const addCaseInvestigationNoteInvestigationByCaseId = ({ caseGuid, payload, onSuccess, onComplete}) => async (dispatch) => {
  try {
    const { data } = await api.caseInvestigationManager.addCaseInvestigationNoteInvestigationByCaseId({ caseGuid, payload });

    onSuccess && onSuccess(data);

  } catch (error) {
    dispatch(
      setAlert({
        title: 'Failed to add investigator note',
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
  } finally {
    onComplete && onComplete();
  }
};


export const setCaseInvestigationManagerToInitialState = () => async (dispatch) => {
  dispatch({
    type: types.SET_CASE_INVESTIGATION_MANAGER_TO_INITIAL_STATE
  });
};
